import { createContext, useContext } from 'react';
import type { AdminRole } from '@echo-work-platform/shared-types';

export interface AdminRoleState {
  roles: AdminRole[];
  isPending: boolean;
  isError: boolean;
}

export const AdminRoleContext = createContext<AdminRoleState | null>(null);

export interface AdminRoles extends AdminRoleState {
  isAdmin: boolean;
  isAiAdmin: boolean;
  isAuditor: boolean;
  hasAnyRole: (roles: AdminRole[]) => boolean;
}

export function useAdminRoles(): AdminRoles {
  const ctx = useContext(AdminRoleContext);
  if (!ctx) throw new Error('useAdminRoles must be used within AdminRoleProvider');
  return {
    ...ctx,
    isAdmin: ctx.roles.includes('ADMIN'),
    isAiAdmin: ctx.roles.includes('AI_ADMIN'),
    isAuditor: ctx.roles.includes('AUDITOR'),
    hasAnyRole: (roles) => roles.some((r) => ctx.roles.includes(r)),
  };
}
